import { ArticleHeading5, ArticleParagraph2, IconArrowUpRight16 } from '@cian/ui-kit';

import { FC } from 'react';

import * as styles from './TooltipContent.css';

export const TooltipContent: FC = () => {
  return (
    <div className={styles['container']}>
      <ArticleHeading5>Коворкинг на 38% дешевле</ArticleHeading5>
      <ArticleParagraph2>обычного офиса, по результатам</ArticleParagraph2>
      <ArticleParagraph2>нашего исследования</ArticleParagraph2>
      <div>
        <a className={styles['link']} href="https://promo.cian.ru/coworking" rel="noreferrer" target="_blank">
          <ArticleParagraph2 color="primary_100">Подробный разбор</ArticleParagraph2>
          <span className={styles['icon']}>
            <IconArrowUpRight16 color="primary_100" />
          </span>
        </a>
      </div>
    </div>
  );
};

TooltipContent.displayName = 'TooltipContent';
